import React, { lazy } from 'react';
import type { Step } from '|/app/services';

const AccessoriesComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-accessories" */ './accessories')
);

export const AccessoriesRoute = ({ step }: { step?: Step | null }) => {
  return <AccessoriesComponent isStepComplete={step?.isComplete} />;
};
